var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { ADDITIONAL_FIELD_TYPES, currency } from '../../config';
var DishHelper = /** @class */ (function () {
    function DishHelper() {
    }
    DishHelper.hasDifferentPrices = function (dish) {
        return dish.priceOptions &&
            Object.keys(dish.priceOptions.reduce(function (acc, item) {
                acc[item.price] = 1;
                return acc;
            }, {})).length > 1;
    };
    DishHelper.getFieldOptions = function (field) {
        return field.value ? field.value.split(', ') : [];
    };
    DishHelper.getDishAdditionalFields = function (additionalFields, fieldValues) {
        return additionalFields
            .map(function (field, index) {
            if (field.type === ADDITIONAL_FIELD_TYPES.MULTIPLE_CHOICE) {
                var selected = Object.entries(fieldValues[index])
                    // @ts-ignore it would be great to add fieldValues type, but leaving for now as it was working
                    .filter(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], val = _b[1];
                    return val > 0;
                })
                    .map(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], val = _b[1];
                    return "".concat(val, "x").concat(key);
                });
                return "".concat(field.name, ": ").concat(selected.join(', '));
            }
            if (field.type === ADDITIONAL_FIELD_TYPES.SINGLE_CHOICE) {
                return "".concat(field.name, ": ").concat(fieldValues[index]);
            }
            if (field.type === ADDITIONAL_FIELD_TYPES.CHECKBOX &&
                !!fieldValues[index]) {
                return "+ ".concat(field.name);
            }
            return null;
        })
            .filter(function (field) { return !!field; });
    };
    DishHelper.formatAddonPrice = function (field) {
        return field.addonPrice ? " (+".concat(field.addonPrice, " ").concat(currency, ")") : '';
    };
    return DishHelper;
}());
export default DishHelper;
